import {
  AnalyticsField,
  FilterComparison,
  FilterLogic,
  PivotTableLayout,
  Widget,
} from '@types'

import { LINKED_TRANSACTION_FIELDS } from '@/views/LinkedData/Transactions/utils/const'
import { DEFAULT_COLS } from '@/views/Dashboards/Dashboard/Widgets/LinkedTransactions/utils/const'
import { DEFAULT_CONFIG_NAME } from '@/components/UI/PivotTable/utils/const'

import { generateRandomKey } from '@/helpers'

export const getDefaultLinkedTransactionsAttrs = (): Widget['attrs'] => ({
  count: 15,
  filter: {
    params: [
      {
        key: generateRandomKey(),
        params: [
          {
            key: generateRandomKey(),
            comparison: FilterComparison.NOTCONTAINS,
            field: LINKED_TRANSACTION_FIELDS.TAGS.field,
            value: 'exclude',
          },
        ],
        logic: FilterLogic.AND,
      },
    ],
    logic: FilterLogic.AND,
  },
  cols: DEFAULT_COLS,
})

export const getDefaultValuePivotAttrs = (): Widget['attrs'] => ({
  index: 0,
  configs: [
    {
      name: DEFAULT_CONFIG_NAME,
      open: true,
      layout: PivotTableLayout.MODERN,
      filter: {
        params: [
          {
            params: [
              {
                key: generateRandomKey(),
                comparison: FilterComparison.NOTEQ,
                field: AnalyticsField.POSITION_CLOSE,
                value: '0',
              },
            ],
            logic: FilterLogic.AND,
            key: generateRandomKey(),
          },
        ],
        logic: FilterLogic.AND,
      },
      sortColumns: [],
      sortRows: [],
    },
  ],
})
